import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  headerButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
}))
